// @flow

// Sentry polyfills console.error to beam logged errors to sentry while also logging them to console.  However, sentry
// is initialized asynchronously, so we need to capture errors ourselves until that happens.
//
// This is in its own file as browsers tend to display the logging file in the console UI, and everything being logged
// from 'polyfill-modern.jsx' misleadingly makes errors appear as if they come from polyfills themselves.

// eslint-disable-next-line no-global-assign
__PRE_SENTRY_ERRORS__ = [];
if (console) {
  const origError = console.error;
  // $FlowFixMe console.error is in fact writable!
  console.error = (...data) => {
    if (__PRE_SENTRY_ERRORS__) {
      __PRE_SENTRY_ERRORS__.push(data);
    }
    try {
      // THIS LINE IS NOT THE SOURCE OF YOUR ERROR!  See the comment at the top of this file.
      origError(...data);
    } catch (ignored) {
      // On IE and Edge, when the devtools are not opened, calls to console do nothing.  Calls to a variable that has
      // been assigned to console throw an exception!  This captures and discards that exception.
      // https://www.beyondjava.net/console-log-surprises-with-internet-explorer-11-and-edge
    }
  };
}
